import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.app-routed-tabs-list-vertical {
  gap: ${dt('appRoutedTabsList.vertical.gap')};

  & .item {
    padding: ${dt('appRoutedTabsList.vertical.item.padding')};
    border-radius: ${dt('appRoutedTabsList.vertical.item.borderRadius')};
    color: ${dt('appRoutedTabsList.vertical.item.color')};
    font-size: ${dt('appRoutedTabsList.vertical.item.fontSize')};
    line-height: ${dt('appRoutedTabsList.vertical.item.lineHeight')};
    font-weight: ${dt('appRoutedTabsList.vertical.item.fontWeight')};
    text-decoration: none;
  }

  & .item .pi {
    font-size: ${dt('appRoutedTabsList.vertical.item.iconSize')};
  }

  & .item:not([data-active]):hover {
    background: ${dt('appRoutedTabsList.vertical.item.hoverBackground')};
  }

  & .item:focus-visible {
    outline: ${dt('focus.ring.width')} ${dt('focus.ring.style')} ${dt('focus.ring.color')};
    outline-offset: ${dt('focus.ring.offset')};
  }

  & .item[data-active] {
    background: ${dt('appRoutedTabsList.vertical.item.activeBackground')};
    color: ${dt('appRoutedTabsList.vertical.item.activeColor')};
    font-weight: ${dt('appRoutedTabsList.vertical.item.activeFontWeight')};
  }
}
`;
